export const MAILCHIMP_ROUTE_NAMES = {
  TEMPLATE_EDIT: 'templateEdit',
  ANALYTICS: 'analytics',
  SEGMENT_LIST: 'segment-list',
  SEGMENT_NEW: 'segment-new',
  SEGMENT_DETAIL: 'segment-detail',
}
